import { MatPaginatorIntl } from '@angular/material/paginator';

export function getMatPaginatorIntlEs(): MatPaginatorIntl {
  const intl = new MatPaginatorIntl();

  intl.itemsPerPageLabel = 'ELEMENTOS POR PAGINA:';
  intl.nextPageLabel = 'SIGUIENTE';
  intl.previousPageLabel = 'ANTERIOR';
  intl.firstPageLabel = 'PRIMERA PAGINA';
  intl.lastPageLabel = 'ULTIMA PAGINA';

  // Texto del rango: "1 – 2 de 2"
  intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) return `0 de ${length}`;

    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);

    // MatPaginator usa 0-based, mostramos 1-based
    return `${startIndex + 1} – ${endIndex} de ${length}`;
  };

  return intl;
}
